import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { catchError, exhaustMap, map, Observable, of } from 'rxjs';
import { logoutUser } from 'src/app/auth/state/actions/auth.actions';
import { selectAuthUser } from 'src/app/auth/state/selectors/auth.selectors';
import { User } from '../models/users';
import { PingService } from '../services/ping.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard  {
  private store = inject(Store);
  private pingSvc = inject(PingService);


  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {

    return this.store.select(selectAuthUser).pipe(
      exhaustMap((user: User.User) => {
        if (user !== null) {
          return this.pingSvc.ping(user._id).pipe(
            map(() => true),
            catchError(() => {
              this.store.dispatch(logoutUser());
              return of(false);
            })
          );
        } else {
          this.store.dispatch(logoutUser());
          return of(false);
        }
      })
    );


  }
}
